import React, { useContext } from 'react';
import styled from 'styled-components';
import { IPanelEstructureElementVoc } from '../../../../types/panelEstructure';
import PanelEstructureContext from '../context/PanelEstructureContext';
import ModuleContext from '../../../../CMFW/context/ModuleContext';
import PanelEstructureModel from '../../../../models/PanelEstructureModel';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store/reducers/rootReducer';
import { AudioPlayer } from '../../../../CMFW/layout/AudioPlayer';
import { IVocDialect } from '../../../../models/VocabularyModel';

export type IProps = {
  data: IPanelEstructureElementVoc;
};

const PanelBlockElementVoc: React.FC<IProps> = ({ data }) => {
  const panelEstructureModel = useContext(ModuleContext) as PanelEstructureModel;
  const courses = useSelector((state: IAppState) => state.courseConfig);
  const courseConfig = courses[panelEstructureModel.courseId];
  const panelEstructureContext = useContext(PanelEstructureContext);
  const defaultTargetId = courseConfig.targetDialectDefaultId;

  const getTargets = (): IVocDialect[] => {
    const targetDialectIds = courseConfig.targetDialects.map((d) => d.dialectId);
    const targets = data.dialects.filter((d) => targetDialectIds.includes(d.dialectId));
    const targetDefault = targets.find((d) => d.dialectId === defaultTargetId);
    if (!targetDefault) {
      return [];
    }
    const targetsNoDefault = targets.filter(
      (d) => d.dialectId !== defaultTargetId && d.targetWithArticle !== targetDefault.targetWithArticle,
    );

    return [targetDefault, ...targetsNoDefault];
  };

  const getSource = (): string => {
    const source = data.dialects.find((d) => d.dialectId === panelEstructureContext.sourceDialectId);
    if (source) {
      return source.source;
    } else {
      return '';
    }
  };

  const targets = getTargets();
  const source = getSource();
  return (
    <Wrapper>
      {targets.map((t) => (
        <RowTarget key={t.dialectId} default={t.dialectId === defaultTargetId}>
          <AudioPlayer key={`audio-${t.audio.refId}-${t.dialectId}`} audio={t.audio} />
          <Target dangerouslySetInnerHTML={{ __html: t.targetWithArticle }} />
        </RowTarget>
      ))}
      <Source dangerouslySetInnerHTML={{ __html: source }} />
    </Wrapper>
  );
};

export default PanelBlockElementVoc;

const Wrapper = styled.div`
  font-size: 16px;
`;
const RowTarget = styled.div<{ default: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  opacity: ${(props) => (props.default ? 1 : 0.5)};
`;
const Target = styled.p`
  margin: 2px 4px 0;
`;

const Source = styled.p`
  color: #00859b;
  padding-left: 28px;
  margin: 0;
`;
